import React from 'react';
import { useImpersonation } from '../contexts/ImpersonationContext';
import { UserX, ArrowLeft } from 'lucide-react';

export default function ImpersonationBanner() {
  const { impersonatedUser, isImpersonating, stopImpersonation } = useImpersonation();

  if (!isImpersonating) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
      color: '#fff',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      fontFamily: "'IBM Plex Sans', sans-serif",
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <UserX size={20} />
        <div>
          <div style={{ fontWeight: 700, fontSize: 14 }}>
            MODE IMPERSONATION
          </div>
          <div style={{ fontSize: 12, opacity: 0.9 }}>
            Vous visualisez l'application en tant que : <strong>{impersonatedUser?.name || impersonatedUser?.username}</strong>
            {impersonatedUser?.role && <span style={{ marginLeft: 8, padding: '2px 6px', background: 'rgba(255,255,255,0.2)', borderRadius: 3, fontSize: 10 }}>{impersonatedUser.role}</span>}
          </div>
        </div>
      </div>
      
      <button
        onClick={stopImpersonation}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '8px 16px',
          background: '#fff',
          color: '#c0392b',
          border: 'none',
          borderRadius: 4,
          fontSize: 13,
          fontWeight: 700,
          cursor: 'pointer',
          transition: 'transform 0.15s',
        }}
        onMouseOver={e => e.currentTarget.style.transform = 'scale(1.02)'}
        onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
      >
        <ArrowLeft size={16} />
        Revenir a mon compte
      </button>
    </div>
  );
}
